module.exports = __webpack_public_path__ + "static/img/Jason_Johannisen_desktop.2e8f972.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jason_Johannisen_desktop.jpg
// module id = Q/3J
// module chunks = 0